<app-header></app-header>

<div class="min-h-screen flex items-center justify-center px-4 sm:px-6 md:px-8 bg-cover bg-center"
    [ngStyle]="{ 'background-image': 'url(assets/images/employee-login.png)' }">
    <div class="bg-white p-4 sm:p-6 md:p-8 rounded-lg w-full max-w-2xl mt-4 card-shadow">
        <div class="flex justify-start mb-4 sm:mb-6 pb-2 border-b-[1px] ">
            <img src="assets/images/logo-red.png" class="h-10 sm:h-12 md:h-14" />
        </div>

        <h2 class="text-center text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mb-2">
            {{ 'EMPLOYEE.USERNAME.TITLE' | translate }}
        </h2>

        <div>
            <p class="text-center text-sm sm:text-base text-gray-500 mb-4 sm:mb-6 font-light">
                {{ 'EMPLOYEE.USERNAME.DESCRIPTION' | translate }}
            </p>
            <form [formGroup]="usernameForm" (ngSubmit)="onSubmit()" class="flex justify-center">
                <div class="w-full max-w-md px-2 sm:px-0 space-y-4 sm:space-y-6">
                    <div>
                        <label class="block text-gray-400 font-light italic text-base sm:text-lg mb-2 sm:mb-4">{{
                            'EMPLOYEE.USERNAME.POLICY_NUMBER' | translate }}</label>
                        <input class="w-full px-3 sm:px-4 py-2.5 sm:py-3 text-base border rounded-3xl focus:outline-none"
                            formControlName="policyNumber"
                            placeholder="{{ 'EMPLOYEE.USERNAME.POLICY_NUMBER' | translate }}" tabindex="1" />
                        <div *ngIf="usernameForm.get('policyNumber')?.invalid && (usernameForm.get('policyNumber')?.dirty || usernameForm.get('policyNumber')?.touched)"
                            class="text-red-500 text-xs sm:text-sm mt-1">
                            <div *ngIf="usernameForm.get('policyNumber')?.errors?.['required']">{{ 'EMPLOYEE.USERNAME.POLICY_NUMBER_REQUIRED' | translate }}</div>
                        </div>
                    </div>

                    <div>
                        <label class="block text-gray-400 font-light italic text-base sm:text-lg mb-2 sm:mb-4">{{
                            'EMPLOYEE.USERNAME.MEMBER_NUMBER' | translate }}</label>
                        <input class="w-full px-3 sm:px-4 py-2.5 sm:py-3 text-base border rounded-3xl focus:outline-none"
                            formControlName="memberNumber"
                            placeholder="{{ 'EMPLOYEE.USERNAME.MEMBER_NUMBER' | translate }}" tabindex="2" />
                        <div *ngIf="usernameForm.get('memberNumber')?.invalid && (usernameForm.get('memberNumber')?.dirty || usernameForm.get('memberNumber')?.touched)"
                            class="text-red-500 text-xs sm:text-sm mt-1">
                            <div *ngIf="usernameForm.get('memberNumber')?.errors?.['required']">{{ 'EMPLOYEE.USERNAME.MEMBER_NUMBER_REQUIRED' | translate }}</div>
                        </div>
                    </div>

                    <div *ngIf="errorMessage" class="text-red-500 text-xs sm:text-sm mt-1 text-center">
                        {{ errorMessage }}
                    </div>

                    <button type="submit" [disabled]="usernameForm.invalid"
                        class="w-full rounded-3xl bg-white border-4 border-red-500 text-red-500 py-3 text-base sm:text-lg font-medium min-h-[48px]"
                        [ngClass]="{ 'opacity-50 cursor-default': usernameForm.invalid, 'active:bg-red-500 active:text-white': !usernameForm.invalid }">
                        {{ 'EMPLOYEE.USERNAME.RECOVER_BUTTON' | translate }}
                    </button>
                </div>
            </form>
        </div>

        <div class="text-center mt-4 sm:mt-6">
            <a routerLink="/employee/account/login" class="text-sm sm:text-base text-red-500 hover:underline min-h-[44px] inline-flex items-center">
                {{ 'EMPLOYEE.USERNAME.BACK_TO_LOGIN' | translate }}
            </a>
        </div>

        <app-card-footer></app-card-footer>
    </div>
</div>
